import {
  AdditionalChargeTransaction,
  AdditionalRefundTransaction,
} from "@/fm/data/orders";

/**
 * Net total after adhoc adjustments: order total + Σ additional charges −
 * Σ additional refunds. Amounts are dollar-denominated floats
 * — the backend stores them as decimals. Both arrays are adhoc-only;
 * modification/cancellation/dispute refunds are surfaced elsewhere.
 *
 * Shared by the order detail price breakdown and the receipt PDF so both
 * reconcile to the same figure.
 */
export function netTotalAfterAdjustments(
  totalPrice: number,
  additionalChargeTransactions: AdditionalChargeTransaction[],
  additionalRefundTransactions: AdditionalRefundTransaction[]
): number {
  const totalCharged = additionalChargeTransactions.reduce(
    (sum, t) => sum + t.amount,
    0
  );
  const totalRefunded = additionalRefundTransactions.reduce(
    (sum, t) => sum + t.amount,
    0
  );
  return totalPrice + totalCharged - totalRefunded;
}
